<template>
  <div id="product-assignment">
    <v-data-table-server
      v-model:options="options"
      dense
      :headers="headers"
      :loading="loading"
      :items="items"
      :items-length="totalItems"
      class="elevation-1"
      :items-per-page-options="footerProps.itemsPerPageOptions"
      @update:options="updateTable"
    >
      <template #top>
        <v-card-title>
          <v-toolbar flat>
            <v-toolbar-title>Product Assignment Models</v-toolbar-title>

            <v-spacer />

            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
              @input="searchTable()"
            />

            <v-spacer />
            <v-btn
              v-if="hasPermission('create lending-strategies::product-assignment')"
              dark
              class="mb-2 btn-bg-deep-blue"
              @click="openProductAssignmentView()"
            >
              <v-icon>mdi-plus</v-icon>
              New Model
            </v-btn>
            <disabled-for-lack-of-role-btn
              v-else
              text="New Product Assignment Model"
              permission="create lending-strategies::product-assignment"
              :x-small="false"
              button-class="mb-2"
            />
          </v-toolbar>
        </v-card-title>
      </template>

      <template #item.actions="{ item }">
        <v-btn
          v-if="hasPermission('edit lending-strategies::product-assignment')"
          justify="space-around"
          small
          class="btn-bg-deep-blue mr-5"

          :to="{ name: 'product-assignment', params: { modelId: item.id } }"
        >
          Edit Model
        </v-btn>

        <disabled-for-lack-of-role-btn
          v-else
          text="Edit Model"
          permission="edit lending-strategies::product-assignment"
          :button="true"
          :chip="false"
          chip-color="error"
        />

        <v-btn
          v-if="hasPermission('create lending-strategies::product-assignment')"
          small
          class="btn-bg-deep-blue"

          @click="openMakeCopyProductAssignmentView(item)"
        >
          Make Copy
        </v-btn>
        <disabled-for-lack-of-role-btn
          v-else
          text="Make Copy"
          permission="edit lending-strategies::product-assignment"
          :button="true"
          :chip="false"
          chip-color="error"
        />
      </template>
    </v-data-table-server>
    <ProductAssignmentModel
      v-if="productAssignmentViewOpen"
      :model-data="activeProductAssignment"
      @model-saved="onProductModelSaved"
      @close-modal="productAssignmentViewOpen = false"
    />
    <ProductAssignmentModalMakeCopy
      v-if="displayDialogMakeCopy"
      :model-data="activeProductAssignment"
      @model-copied="handleModelCopied"
      @close-modal="displayDialogMakeCopy = false"
    />
  </div>
</template>

<script>
import dataTableMixin from '@/mixins/dataTableMixin.js';
import DisabledForLackOfRoleBtn from '../../DisabledForLackOfRoleBtn.vue';
import ProductAssignmentModel from './ProductAssignmentModel.vue';
import ProductAssignmentModalMakeCopy from './ProductAssignmentModalMakeCopy.vue';

export default {
  components: {
    DisabledForLackOfRoleBtn,
    ProductAssignmentModel,
    ProductAssignmentModalMakeCopy,
  },

  mixins: [
    dataTableMixin,
  ],

  data: () => ({
    headers: [
      { title: 'ID', value: 'id' },
      { title: 'Name', value: 'name' },
      { title: 'Description', value: 'description' },
      { title: 'Endpoint', value: 'endpoint' },
      {
        title: 'Actions',
        value: 'actions',
        sortable: false,
        width: 250,
      },
    ],

    activeProductAssignment: null,
    productAssignmentViewOpen: false,
    displayDialogMakeCopy: false,
  }),

  watch: {
    '$route.params.modelId': {
      handler() {
        this.productAssignmentViewOpen = false;
        this.openActiveModel();
      },
      immediate: true,
    },
  },

  methods: {
    handleModelCopied(model) {
      this.items.push(model);
      this.$router.push({ name: 'product-assignment', params: { modelId: model.id } });
    },

    openMakeCopyProductAssignmentView(model) {
      this.activeProductAssignment = model;
      this.displayDialogMakeCopy = true;
    },

    openProductAssignmentView(model = {}) {
      this.activeProductAssignment = model;
      this.productAssignmentViewOpen = true;
    },

    onProductModelSaved(modelData) {
      const index = this.items.findIndex((item) => item.id === modelData.id);

      if (index !== -1) {
        this.items.splice(index, 1, modelData);
      } else {
        this.items.push(modelData);
        this.$router.push({ name: 'product-assignment', params: { modelId: modelData.id } });
      }
    },

    updateTable() {
      this.loading = true;

      return this.$axios
        .get('api/v1/product-assignment-model', {
          params: {
            perPage: this.options.itemsPerPage,
            page: this.options.page,
            ...this.sortParams,
            search: this.search,
          },
        })
        .then((res) => {
          this.loading = false;
          this.items = res.data.data;
          this.totalItems = res.data.total;

          this.openActiveModel();
        });
    },

    openActiveModel() {
      const { modelId } = this.$route.params;
      const activeModel = this.items.find((item) => Number(item.id) === Number(modelId));

      if (activeModel) {
        this.openProductAssignmentView(activeModel);
      }
    },
  },
};
</script>
